import { useOutletContext } from "react-router";
import type { Domain, Section } from "@/shell/nav";
import { Empty, Page } from "@/components/page";

interface ShellContext {
  domain: Domain;
  section: string;
  accountId?: string;
}

/** Stands in for a screen that has not been built yet; lists the API it will drive. */
export function PlaceholderPage() {
  const { domain, section, accountId } = useOutletContext<ShellContext>();
  const s: Section | undefined = domain.sections.find((x) => x.id === section);
  return (
    <Page title={s?.label ?? section} meta={domain.scope === "account" ? accountId : "platform"}>
      <Empty title="Not built yet">
        {s?.endpoints?.length ? (
          <ul className="mt-2 space-y-0.5 text-left font-mono text-2xs">
            {s.endpoints.map((e) => (
              <li key={e}>{e}</li>
            ))}
          </ul>
        ) : (
          "This section is on the plan in doc/engineering/switchboard/README.md."
        )}
      </Empty>
    </Page>
  );
}
